import { CustomDataProjectDto, CustomDataUploadPollingDto, CustomDataUploadStatuses, UploadCustomDataPresignedUrlDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface CustomDataUploadUrlQuery {
  projectId?: string | undefined;
  projectName?: string | undefined;
  fileType?: string | undefined;
}

export interface FileUploadInfo {
  name?: string;
  size?: number;
  presignedUploadUrl?: string;
  files?:File[];
  state?:LoadingState;
  error?:string;
  cancellationToken?: AbortController;
  validationError?:string;
}
export const initialFileInfoState: FileUploadInfo = {
  state:LoadingState.idle,
}

export interface CustomDataProjectState {
  createCustomDataProjectState: LoadingState;
  getCustomDataProjectLoadingState: LoadingState;
  customDataProject: CustomDataProjectDto | null;
  getProjectError?: string;
  isCustomDataUploadDialogOpened: boolean;
  isCustomUploadDialogAutoClose:boolean;
  uploadUrls: UploadCustomDataPresignedUrlDto | null;
  uploadUrlsLoadingState: LoadingState;
  uploadUrlsError?: string;
  dataFileInfo:FileUploadInfo;
  dictionaryFileInfo:FileUploadInfo;
  fileFormat: string;
  dataStructure: string;
  token?: string;
  pollingStatus?:CustomDataUploadStatuses;
  pollingMessage?:string;
  createCustomDataUploadPollingLoadingState:LoadingState;
  customDataUploadPollingLoadingState:LoadingState;
  customDataUploadPollingData?: CustomDataUploadPollingDto;
  customDataUploadPollingDataErrorMessage?:string;
  preAssignedToken?:string;
}

export const initialCustomDataProjectState: CustomDataProjectState = {
  createCustomDataProjectState: LoadingState.idle,
  getCustomDataProjectLoadingState:LoadingState.idle,
  uploadUrlsLoadingState: LoadingState.idle,
  customDataProject: null,
  uploadUrls: null,
  isCustomDataUploadDialogOpened: false,
  isCustomUploadDialogAutoClose: false,
  fileFormat: "sav",
  dataStructure: "flat",
  dataFileInfo: initialFileInfoState,
  dictionaryFileInfo: initialFileInfoState,
  createCustomDataUploadPollingLoadingState:LoadingState.idle,
  customDataUploadPollingLoadingState:LoadingState.idle,
};
